const MAINTENANCE_CONFIG = {
  enabled: true, // Set to false to disable the popup
  startTime: new Date('2026-03-19T14:35:00'),
  endTime: new Date('2026-03-19T15:00:00')
};

function isMaintenanceTime() {
  const now = new Date();
  return now >= MAINTENANCE_CONFIG.startTime && now <= MAINTENANCE_CONFIG.endTime;
}

function showMaintenancePopup() {
  if (!MAINTENANCE_CONFIG.enabled || !isMaintenanceTime()) {
    return;
  }

  // Check if popup already exists
  if (document.getElementById('maintenance-popup')) {
    return;
  }

  const popupHTML = `
    <div id="maintenance-popup" class="maintenance-popup-overlay">
      <div class="maintenance-popup-content">
        <div class="maintenance-popup-icon">🔧</div>
        <h2 class="maintenance-popup-title">Website Under Maintenance</h2>
        <p class="maintenance-popup-message">
          We're currently performing scheduled maintenance to improve your experience.
          The website will be unavailable during this time.
        </p>
        <p class="maintenance-popup-time">
          2:35 PM - 3:00 PM (March 19, 2026)
        </p>
        <p class="maintenance-popup-message" style="margin-top: 20px; font-size: 14px;">
          Thank you for your patience!
        </p>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', popupHTML);
  
  // Prevent scrolling
  document.body.style.overflow = 'hidden';
  
  // Prevent closing the popup
  const popup = document.getElementById('maintenance-popup');
  popup.addEventListener('click', function(e) {
    e.stopPropagation();
    e.preventDefault();
  });
  
  // Disable all interactive elements except the popup
  disablePageInteraction();
}

function disablePageInteraction() {
  const allElements = document.querySelectorAll('a, button, input, select, textarea');
  allElements.forEach(element => {
    if (!element.closest('#maintenance-popup')) {
      element.style.pointerEvents = 'none';
      element.setAttribute('tabindex', '-1');
    }
  });
}

function hideMaintenancePopup() {
  const popup = document.getElementById('maintenance-popup');
  if (popup) {
    popup.remove();
    document.body.style.overflow = '';
    
    // Re-enable page interaction
    const allElements = document.querySelectorAll('a, button, input, select, textarea');
    allElements.forEach(element => {
      element.style.pointerEvents = '';
      element.removeAttribute('tabindex');
    });
  }
}

// Check maintenance status on page load
document.addEventListener('DOMContentLoaded', function() {
  showMaintenancePopup();
  
  // Check every minute if maintenance period has ended
  setInterval(function() {
    if (MAINTENANCE_CONFIG.enabled && isMaintenanceTime()) {
      showMaintenancePopup();
    } else {
      hideMaintenancePopup();
    }
  }, 60000); // Check every 60 seconds
});
